import React, { useState, useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { API_URL } from '../Config';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const InvoicePaymentAllocation = ({
  customer_id: propCustomerId,
  fromDate: propFromDate,
  toDate: propToDate,
  onClose,
  onSuccess,
  API_URL: propApiUrl,
  accessToken: propAccessToken,
  isModal = false
}) => {
  const navigate = useNavigate();
  const { customer_id: paramCustomerId } = useParams();

  const customer_id = propCustomerId || paramCustomerId;
  const accessToken = propAccessToken || localStorage.getItem('accessToken');
  const apiUrl = propApiUrl || API_URL;

  const [fromDate, setFromDate] = useState(propFromDate || '');
  const [toDate, setToDate] = useState(propToDate || '');
  const [allocationAmount, setAllocationAmount] = useState(0);
  const [order, setOrder] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [invoiceAllocationAmount, setInvoiceAllocationAmount] = useState(0);
  const [checkedInvoices, setCheckedInvoices] = useState(new Set());

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedInvoices.length === 0) {
      Swal.fire('Warning', 'Please select at least one invoice', 'warning');
      return;
    }

    const formData = new FormData();
    formData.append('customer_id', customer_id);
    selectedInvoices.forEach((invoice) => {
      formData.append('ids[]', invoice.invoiceNumber);
      formData.append('sources[]', invoice.source);
    });

    try {
      const response = await fetch(`${apiUrl}/SubmitInvoicePaymentAllocation`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        body: formData,
      });

      const data = await response.json();
      if (data.success) {
        Swal.fire('Success', data.message || 'Invoice payment allocation submitted', 'success');
        setSelectedInvoices([]);
        setInvoiceAllocationAmount(0);
        setCheckedInvoices(new Set());
        if (onSuccess) onSuccess();
        if (!isModal) navigate('/account/customer_accounts');
      } else {
        Swal.fire('Error', 'Failed to allocate payment', 'error');
      }
    } catch (error) {
      console.error('Error submitting allocation:', error);
      Swal.fire('Error', 'An error occurred while submitting allocation', 'error');
    }
  };

  const fetchData = async () => {
    if (!customer_id) return;

    const formData = new FormData();
    formData.append('searchByFromdate', fromDate);
    formData.append('searchByTodate', toDate);
    formData.append('customer_id', customer_id);

    try {
      const response = await fetch(`${apiUrl}/InvoicePaymentAllocation`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        body: formData,
      });

      const data = await response.json();
      if (data.success && data.data) {
        setOrder(data.data.customer_order || []);
        setAllocationAmount(data.data.allocation_amout[0]?.total || 0);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate, customer_id]);

  useEffect(() => {
    if (order.length > 0) {
      if ($.fn.DataTable.isDataTable('#pushtosagelist')) {
        $('#pushtosagelist').DataTable().destroy();
      }

      const table = $('#pushtosagelist').DataTable({
        pageLength: 50,
        data: order,
        columns: [
          {
            data: null,
            title: 'S.No',
            width: '50px',
            render: (data, type, row, meta) => meta.row + 1
          },
          { data: 'invoice_date', title: 'Date' },
          { data: 'reference_no', title: 'Invoice Number' },
          {
            data: 'grand_total',
            title: 'Amount',
            render: data => parseFloat(data).toFixed(2),
            className: 'text-end'
          },
          {
            data: 'paid',
            title: 'Paid',
            render: data => parseFloat(data).toFixed(2),
            className: 'text-end'
          },
          {
            data: 'balance',
            title: 'Balance',
            render: data => parseFloat(data).toFixed(2),
            className: 'text-end'
          },
          {
            data: null,
            title: 'Allocate',
            render: row => `<input type="checkbox" class="select-checkbox" data-id="${row.id}" data-grandtotal="${row.balance}" data-source="${row.source}" />`,
            orderable: false
          },
        ],
        destroy: true,
        searching: true,
        info: true,
        lengthChange: true,
        dom: '<"toprow d-flex justify-content-between align-items-end mb-3"<"left"l><"right"f>>rt<"bottomrow d-flex justify-content-between mt-2"<"left"i><"right"p>>',
        language: {
          //  search: "",
          // searchPlaceholder: "Search invoices...",
          lengthMenu: "Show _MENU_",
          info: "Showing _START_ to _END_ of _TOTAL_ invoices",
          infoEmpty: "No invoices found",
          infoFiltered: "(filtered from _MAX_ total invoices)",
        },
        searchDelay: 300,
        search: {
          caseInsensitive: true
        }
      });

      $('#customSearchBox').on('keyup', function () {
        table.search(this.value).draw();
      });

      $('#pushtosagelist').on('change', '.select-checkbox', function () {
        const invoiceNumber = $(this).data('id');
        const grandTotal = parseFloat($(this).data('grandtotal'));
        const source = $(this).data('source');

        if (this.checked) {
          setCheckedInvoices(prev => new Set(prev.add(invoiceNumber)));
          setSelectedInvoices(prev => [...prev, { invoiceNumber, grandTotal, source }]);
        } else {
          setCheckedInvoices(prev => {
            const updated = new Set(prev);
            updated.delete(invoiceNumber);
            return updated;
          });
          setSelectedInvoices(prev => prev.filter(inv => inv.invoiceNumber !== invoiceNumber));
        }
      });

      return () => {
        if ($.fn.DataTable.isDataTable('#pushtosagelist')) {
          $('#pushtosagelist').DataTable().destroy();
        }
      };
    }
  }, [order]);

  useEffect(() => {
    const newTotal = selectedInvoices.reduce((total, inv) => total + inv.grandTotal, 0);
    setInvoiceAllocationAmount(newTotal.toFixed(2));
  }, [selectedInvoices]);

  const renderContent = () => (
    <div>
      <div style={{ position: 'relative', top: '55px', left: '130px' }} className="mb-3">
        <div className="row align-items-end mb-3">
          <div className="col-md-3">
            <label className="form-label"><b>Amt Available</b></label>
            <input
              type="text"
              className="form-control text-end"
              value={Number(allocationAmount).toFixed(2)}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label className="form-label"><b>Amt Allocated</b></label>
            <input
              type="text"
              className="form-control text-end"
              value={invoiceAllocationAmount}
              readOnly
            />
          </div>
          {/* <div className="col-md-6">
          <label className="form-label"><b>Search</b></label>
          <input
            type="search"
            id="customSearchBox"
            className="form-control"
            placeholder="Search invoices by number, date, or amount..."
          />
        </div> */}
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered" id="pushtosagelist">
          <thead>
            <tr>
              <th style={{ width: '50px' }}>S.No</th>
              <th>Date</th>
              <th>Invoice Number</th>
              <th className="text-end">Amount</th>
              <th className="text-end">Paid</th>
              <th className="text-end">Balance</th>
              <th>Allocate</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>

      <div className="text-end mt-3">
        {isModal && (
          <button className="btn btn-secondary me-2" onClick={onClose}>
            Cancel
          </button>
        )}
        <button className="acceptbtn" onClick={handleSubmit} >
          Submit Allocation
        </button>
      </div>
    </div>
  );

  return isModal ? (
    renderContent()
  ) : (
    <div>
      <Header />
      <div className="main-container">
        <div className="container-fluid" style={{ marginTop: '-70px' }}>
          {renderContent()}
        </div>

      </div>
      <Footer />
    </div>
  );
};

export default InvoicePaymentAllocation;
